import { render, staticRenderFns } from "./TabelaDevedor.vue?vue&type=template&id=67574838&scoped=true&"
import script from "./TabelaDevedor.vue?vue&type=script&lang=js&"
export * from "./TabelaDevedor.vue?vue&type=script&lang=js&"
import style0 from "./TabelaDevedor.vue?vue&type=style&index=0&id=67574838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67574838",
  null
  
)

export default component.exports